import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";

const EASE = [0.16, 1, 0.3, 1];

const STORIES = [
  {
    quote:
      "I came in embarrassed by a number I didn't understand. I left with a plan, a coach, and 118 points of proof that understanding changes everything.",
    name: "Danielle R.",
    context: "Coaching client, 11 months",
  },
  {
    quote:
      "Nobody had ever explained my own report to me before. The analysis session alone was worth more than years of guessing — and the roadmap actually worked.",
    name: "Marcus T.",
    context: "Action plan client",
  },
  {
    quote:
      "My company went from 'no file' to fundable. Elevated Apex sequenced everything — vendors, reporting, timing — so the lenders saw exactly what they needed to see.",
    name: "Priya S.",
    context: "Business funding client",
  },
];

const Testimonials = () => (
  <section id="stories" className="py-28 lg:py-40 bg-ink-surface border-y border-white/10" data-testid="stories-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <SectionHeading
        overline="Client Stories"
        title={<>Elevation, in their<br /><span className="italic text-gold">own words.</span></>}
        testId="stories-heading"
      />

      <div className="mt-16 lg:mt-24 grid grid-cols-1 lg:grid-cols-3 gap-5">
        {STORIES.map((s, i) => (
          <motion.figure
            key={s.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.12, ease: EASE }}
            className="group bg-ink-base border border-white/10 p-8 lg:p-10 flex flex-col hover:border-gold/40 transition-colors duration-500"
            data-testid={`testimonial-card-${i + 1}`}
          >
            <Quote className="w-6 h-6 text-gold/60" strokeWidth={1.25} />
            <blockquote className="mt-6 font-serif text-lg lg:text-xl text-neutral-200 leading-relaxed italic flex-1">
              "{s.quote}"
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-white/10 flex items-baseline justify-between">
              <span className="font-sans text-sm text-white">{s.name}</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">{s.context}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
